import React from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ListingDetails.css';
import {
  Row,
  Col,
  Collapse,
  Button
} from 'react-bootstrap';
import cx from 'classnames';

//Images
import IconDefault from '../../../../public/SiteIcons/defaultIcon.png';

// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
import * as FontAwesome from 'react-icons/lib/fa';

// Locale
import messages from '../../../locale/messages';

import TickImage from '../../../../public/SiteImages/featureTick.svg';

class ListItem extends React.Component {
  static propTypes = {
    itemList: PropTypes.arrayOf(PropTypes.shape({
      listsettings: PropTypes.shape({
        itemName: PropTypes.string,
        settingsType: PropTypes.shape({
          typeName: PropTypes.string
        }),
      }),
      spacesId: PropTypes.string,
    })).isRequired,
    label: PropTypes.string.isRequired,
  };

  static defaultProps = {
    itemList: [],
    showLabel: 'Show More Description',
    hideLabel: 'Hide Description',
    icon: false,
    bare: false,
    pills: false,
    count: 4
  };

  static featurePriorty = [[135, 'Waterfront'],
                           [27, '24/7 Access'],
                           [136, 'Day Care'],
                           [118, 'Parking'],
                           [113, 'Keyless'],
                           [137, 'Phone Booths'],
                           [119, 'Swimming Pool'],
                           [130, 'Gym'],
                           [138, 'Roof Terrace'],
                           [97, 'Cafe'],
                           [87, 'Bicycle Storage'],
                           [129, 'Cycle Racks'],
                           [106, '24/7 Security'],
                           [26, 'Wi-Fi'],
                         ];

  constructor(props) {
    super(props);
    this.state = {
      open: false,
    }
    this.handleClick = this.handleClick.bind(this);

  }

  handleClick() {
    this.setState({ open: !this.state.open })
  }

  render() {
    const { itemList, label, showLabel, hideLabel, icon, houseRulesClassName, bare, pills, count } = this.props;
    const { open } = this.state;

    let firstArray, restArray, dotString = false;

    let itemListData = itemList && itemList.length > 0 ? itemList.filter(o => o.listsettings.isEnable == "1") : [];

    if( pills ) {
      let mainFeatures = [];
      let otherFeatures = [];

      let featureMapArray = [];

      itemListData.map((item, key) => {
        featureMapArray = [...featureMapArray, [Number(item.amenitiesId), item]];

        if( item.listsettings.image ) {
          mainFeatures = [...mainFeatures, item];
        }
        else {
          otherFeatures = [...otherFeatures, item];
        }
      });

      if( bare ) {
        let features = [...mainFeatures, ...otherFeatures]; //re-ordered to prioritise main
        mainFeatures = [];
        otherFeatures = [];

        let featureMap = new Map(featureMapArray);
        ListItem.featurePriorty.every(item => {
          let feature = featureMap.get(item[0]);
          if( feature ) mainFeatures = [...mainFeatures, feature];
          return mainFeatures.length < count;
        });
        
        //mainFeatures = itemListData.filter(o => !!ListItem.featurePriorty.get(Number(o.amenitiesId)));
        
        if( mainFeatures.length < count ) {
          let featurePriortyMap = new Map(ListItem.featurePriorty);
          features.every(item => {
            if( !featurePriortyMap.get(Number(item.amenitiesId)) ) {
              mainFeatures = [...mainFeatures, item];
            }
            return mainFeatures.length < count;
          });
        }
      }
      
      if (otherFeatures && otherFeatures.length > 0) {
        dotString = true;
      }

      let list = (
      <div>
      {
        mainFeatures.map((item, key) => {
          if (item.listsettings.isEnable === "1") {
            return ( pills ? (
              <div
                key={key}
                className={s.wifiBtnDisplay}
              >
                <Button className={s.wifiBtnText}>
                { icon && <span>
                  {
                    item.listsettings.image ?
                    <img src={'/images/amenities/' + item.listsettings.image} className={s.wifiBtnTextImage} /> :
                    <img src={TickImage} className={s.featureTickIcon} />
                  }
                </span>}
                <span>
                  {item.listsettings.itemName}
                </span>
                </Button>
              </div> ) : (
              <div
              key={key}
              className={cx(s.splitList, s.vtrTop, s.space2)}
            >
              { icon && <span className={cx(s.listIcon, 'listIconRtl')}>
                {
                  item.listsettings.image ?
                  <img src={'/images/amenities/' + item.listsettings.image} className={cx(s.imgSection, 'imgSectionRtl')} /> :
                  <img src={TickImage} className={s.featureTickIcon} />
                }
              </span>}
              <span className={cx(s.text, s.overflowText, s.listContent)}>
                {item.listsettings.itemName}
              </span>
            </div> )
            )
          }
        })
      }
      { otherFeatures && otherFeatures.length > 0 &&
      <Collapse className={s.collapseContainer} in={open}>
        <div>
          { otherFeatures.map((item, key) => {
              if (item.listsettings.isEnable === "1") {
                return (
                  <div
                    key={key}
                    className={s.wifiBtnDisplay}
                  >
                    <Button className={s.wifiBtnText}>
                    <span>
                      <img src={TickImage} className={s.featureTickIcon} />
                    </span>
                    <span>
                      {item.listsettings.itemName}
                    </span>
                    </Button>
                  </div>
                )
              }
            })
          }
        </div>
      </Collapse>
      }
      {
        dotString && <div className={s.showHideMargin}>
          <Button
            bsStyle="link"
            type="button"
            className={cx(s.btn, s.btnLink, s.btnLinkSecondary, s.toggleLink, s.showHideBtn, s.noPadding)}
            onClick={() => this.handleClick()}
          >
            {this.state.open ? hideLabel : showLabel}
            {
              this.state.open && <FontAwesome.FaAngleUp className={s.toggleIcon} />
            }
            {
              !this.state.open && <FontAwesome.FaAngleDown className={s.toggleIcon} />
            }
          </Button>
        </div>
      }
      </div>
      );

      return ( bare ? list :
        <div className={cx(s.horizontalLineThrough)}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} className={cx(s.space1)}>
              <p className={cx(s.subTitle)}>{label}</p>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
                  {list}
            </Col>
          </Row>
        </div>
      );
    }
    else {
      if (itemListData) {
        firstArray = itemListData.slice(0, count);
        restArray = itemListData.slice(count, itemListData.length);
      }
      if (restArray && restArray.length > 0) {
        dotString = true;
      }

      return (
        <div className={cx(s.horizontalLineThrough)}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} className={cx(s.space1)}>
              <p className={cx(s.subTitle)}>{label}</p>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} className={cx(s.spaceTop1)}>
              <Row>
                <Col md={12} lg={12} xs={12} sm={12}>
                  {
                    firstArray.map((item, key) => {
                      if (item.listsettings.isEnable === "1") {
                        return (
                          <div
                            key={key}
                            className={cx(s.splitList, s.vtrTop, s.space2)}
                          >
                            { icon && <span className={cx(s.listIcon, 'listIconRtl')}>
                              {
                                item.listsettings.image ?
                                <img src={'/images/amenities/' + item.listsettings.image} className={cx(s.imgSection, 'imgSectionRtl')} /> :
                                <img src={TickImage} className={s.featureTickIcon} />
                              }
                            </span>}
                            <span className={cx(s.text, s.overflowText, s.listContent)}>
                              {item.listsettings.itemName}
                            </span>
                          </div>
                        )
                      }
                    })
                  }
                  <Collapse className={s.collapseContainer} in={open}>
                    <div>
                      {
                        restArray && restArray.length > 0 && restArray.map((item, key) => {
                          if (item.listsettings.isEnable === "1") {
                            return (
                              <p
                                key={key}
                                className={cx(s.splitList, s.vtrTop)}
                              >
                                { icon && <span className={cx(s.listIcon, 'listIconRtl')}>
                                  {
                                    item.listsettings.image ?
                                    <img src={'/images/amenities/' + item.listsettings.image} className={cx(s.imgSection, 'imgSectionRtl')} /> :
                                    <img src={TickImage} className={s.featureTickIcon} />
                                  }
                                </span>}
                                <span className={cx(s.text, s.overflowText)}>
                                  {item.listsettings.itemName}
                                </span>
                              </p>
                            )
                          }
                        })
                      }
                    </div>
                  </Collapse>
                  {
                    dotString && <div className={s.showHideMargin}>
                      <Button
                        bsStyle="link"
                        type="button"
                        className={cx(s.btn, s.btnLink, s.btnLinkSecondary, s.toggleLink, s.showHideBtn, s.noPadding)}
                        onClick={() => this.handleClick()}
                      >
                        {this.state.open ? hideLabel : showLabel}
                        {
                          this.state.open && <FontAwesome.FaAngleUp className={s.toggleIcon} />
                        }
                        {
                          !this.state.open && <FontAwesome.FaAngleDown className={s.toggleIcon} />
                        }
                      </Button>
                    </div>
                  }
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      );
    }
  }

}

export default injectIntl(withStyles(s)(ListItem));


// WEBPACK FOOTER //
// src/components/ViewListing/ListingDetails/ListItem.js